module.exports = __webpack_public_path__ + "static/media/03_negro.049a935f.svg";